<script>
  import Loader from '@/_legacy/components/Icons/Loader.vue';
  import Promised from '@/_legacy/components/Promised.vue';

  export default {
    name: 'LoadingButton',
    components: {
      Loader,
      Promised,
    },
    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
      asyncData: {
        required: false,
        validator: p => p
          && typeof p.then === 'function'
          && typeof p.catch === 'function',
      },
    },
  };
</script>

<template>
  <button class="btn btn-default" v-bind="$props" v-on="$listeners">
    <template v-if="asyncData">
      <Promised :async-data="asyncData">
        <slot></slot>

        <span slot="rejected" class="text-base text-red py-2">{{ $t('common.error') }}</span>
      </Promised>
    </template>
    <template v-else>
      <Loader v-if="isLoading" />
      <slot v-else></slot>
    </template>
  </button>
</template>
